import React from "react";
import { useTranslation } from "react-i18next";
import MarkerAudio from "./MarkerAudio";
import MarkerImage from "./MarkerImage";
import MarkerVideo from "./MarkerVideo";
import UrlMarkerForm from "./UrlMarkerForm";
import StyledText from "../../util/StyledText";
import {
  buildMainImageChoices,
  suffixDuplicateNames,
} from "../../../domain/mainImage";

const RessourceMarkerForm = ({
  marker,
  setMarkers,
  showInputAudio,
  showInputImage,
  showInputVideo,
  setShowInputAudio,
  setShowInputImage,
  setShowInputVideo,
  markerImage,
  markerVideo,
  markerAudio,
  markerImageName,
  markerVideoName,
  markerAudioName,
  setMarkerImage,
  setMarkerVideo,
  setMarkerAudio,
  setMarkerImageName,
  setMarkerVideoName,
  setMarkerAudioName,
  mainImage,
  onChooseMainImage,
  onRemoveImage,
  imageIds,
  handleAudioChange,
  handleVideoChange,
  handleImageChange,
  handleDeleteAllAudio,
  handleDeleteAllImage,
  handleDeleteAllVideo,
  updateAudioName,
  updateImageName,
  updateVideoName,
  markerTitle,
  setMarkerTitle,
  markerDescription,
  setMarkerDescription,
  url,
  setUrl,
}) => {
  const { t } = useTranslation();

  // Lot « image principale » (2026-10-01, F8/F9) : le sélecteur ne concerne
  // QUE les images et n'apparaît qu'à partir de deux d'entre elles. La
  // valeur est l'identité stable (checksum serveur ou clé locale, jamais
  // un nom). F8 : les noms sont pris TELS QUELSS, alignés sur imageIds —
  // aucun filter(Boolean) séparé qui désalignerait le tableau parallèle ;
  // les homonymes sont distingués par le suffixe visuel (2), (3).
  const imageNames = Array.isArray(markerImageName) ? markerImageName : [];
  // F9 : homonymes suffixés visuellement (2), (3)… sans changer
  // l'identité — l'UTILISATEUR distingue, le contrat reste stable.
  const displayedImageNames = suffixDuplicateNames(imageNames);
  const mainImageChoices = buildMainImageChoices({
    ids: imageIds,
    names: imageNames,
  });
  const showMainImageSelect = mainImageChoices.length >= 2;

  return (
    <>
      <div className="m-4">
        <label className="mt-4">{t("title")}</label>
        <StyledText
          markerText={markerTitle}
          setMarkerText={setMarkerTitle}
          testId="title-input"
        />
        <label className="mt-4">{t("description")}</label>
        <StyledText
          markerText={markerDescription}
          setMarkerText={setMarkerDescription}
          testId="description-input"
        />
      </div>
      {/* /////////////////////////////////////////////affichage d'image ////////////////////////////////////////////////// */}
      <label className="mt-4">{t("picture")}</label>

      {markerImage && (
        <>
          <MarkerImage
            setMarkers={setMarkers}
            markerImage={markerImage}
            marker={marker}
            setMarkerImageName={setMarkerImageName}
            markerImageName={displayedImageNames}
            // Constat 5 (2e revue du 01/10) : nom BRUT pour le callback,
            // la suppression et la résolution — le suffixé (2), (3) reste
            // purement visuel/aria et ne doit jamais fuiter dans un nom
            // persisté (mainResource) ou un discard.
            rawImageNames={imageNames}
            setRawImageNames={setMarkerImageName}
            markerVideoName={markerVideoName}
            markerAudioName={markerAudioName}
            setMarkerImage={setMarkerImage}
            mainImage={mainImage}
            imageIds={imageIds}
            onChooseMainImage={onChooseMainImage}
            onRemoveImage={onRemoveImage}
          />
          {markerImage &&
            markerImage.length > 1 && (
              <>
                <button
                  type="button"
                  className="buttonDeleteFile mt-3 mb-3 w-50"
                  onClick={handleDeleteAllImage}
                >
                  {t("deleteAll")}
                </button>
                <br />
              </>
            )}
        </>
      )}
      {showInputImage && (
        <>
          <input
            type="hidden"
            value={markerImageName}
            onChange={updateImageName}
          />
          <input
            className="inputAddFile"
            type="file"
            aria-label="input-image"
            accept=".jpg, .jpeg, .png, .gif"
            onChange={handleImageChange}
            multiple
          />
        </>
      )}

      {!showInputImage && (
        <>
          <button
            type="button"
            className="buttonModifMarker mt-1"
            onClick={() => setShowInputImage(true)}
            aria-label="btn-image"
          >
            {t("addPicture")}
          </button>
          <br />
        </>
      )}
      {/* /////////////////////////////////////////////affichage de video ////////////////////////////////////////////////// */}
      <br />
      <label className="mt-4">{t("video")}</label>
      {markerVideo && (
        <>
          <MarkerVideo
            setMarkers={setMarkers}
            markerVideo={markerVideo}
            marker={marker}
            setMarkerVideoName={setMarkerVideoName}
            markerImageName={markerImageName}
            markerVideoName={markerVideoName}
            markerAudioName={markerAudioName}
            setMarkerVideo={setMarkerVideo}

          />
          {markerVideo &&
            markerVideo.length > 1 && (
              <>
                <button
                  type="button"
                  className="buttonDeleteFile mt-3 mb-3 w-50"
                  onClick={handleDeleteAllVideo}
                >
                  {t("deleteAll")}
                </button>
                <br />
              </>
            )}
        </>
      )}
      {showInputVideo && (
        <>
          <input
            type="hidden"
            value={markerVideoName}
            onChange={updateVideoName}
          />
          <input
            className="inputAddFile"
            type="file"
            aria-label="input-video"
            accept=".mp4, .mov"
            onChange={handleVideoChange}
            multiple
          />
        </>
      )}
      {!showInputVideo && (
        <>
          <button
            type="button"
            className="buttonModifMarker mt-1"
            onClick={() => setShowInputVideo(true)}
            aria-label="btn-video"
          >
            {t("addVideo")}
          </button>
        </>
      )}
      {/* /////////////////////////////////////////////affichage d'audio ////////////////////////////////////////////////// */}
      <br />
      <label className="mt-4">Audio</label>

      {markerAudio && (
        <>
          <MarkerAudio
            setMarkers={setMarkers}
            markerAudio={markerAudio}
            marker={marker}
            setMarkerAudioName={setMarkerAudioName}
            markerVideoName={markerVideoName}
            markerAudioName={markerAudioName}
            setMarkerAudio={setMarkerAudio}
          />
          {markerAudio &&
            markerAudio.length > 1 && (
              <>
                <button
                  type="button"
                  className="buttonDeleteAll mt-3 mb-3"
                  onClick={handleDeleteAllAudio}
                >
                  {t("deleteAll")}
                </button>
                <br />
              </>
            )}
        </>
      )}
      {showInputAudio && (
        <>
          <input
            type="hidden"
            value={markerAudioName}
            onChange={updateAudioName}
          />
          <input
            className="inputAddFile"
            type="file"
            aria-label="input-audio"
            accept="audio/*"
            onChange={handleAudioChange}
            multiple
          />
        </>
      )}
      {!showInputAudio && (
        <>
          <button
            type="button"
            className="buttonModifMarker mt-1"
            onClick={() => setShowInputAudio(true)}
            aria-label="btn-audio"
          >
            {t("addAudio")}
          </button>
          <br />
        </>
      )}
      {showMainImageSelect && (
        <div>
          {/* F9 : label/select liés par htmlFor/id (association accessible). */}
          <label className="mt-4" htmlFor="input-MainImage">
            {t("mainImage")}
          </label>
          <select
            className="selectMarker"
            id="input-MainImage"
            value={mainImage}
            onChange={(event) => {
              // Constat f6 (revue finale du 01/10) : le nom notifié est
              // TOUJOURS le BRUT de l'index du tableau ids — si l'id du
              // changement est introuvable (état incohérent), le nom est
              // "" : JAMAIS le libellé suffixé (choice.label), qui
              // corrompait mainResource en « photo.png (2) ».
              const rawIndex = (imageIds || []).indexOf(event.target.value);
              const rawName = rawIndex >= 0 ? imageNames[rawIndex] : "";
              onChooseMainImage(event.target.value, rawName);
            }}
          >
            {mainImageChoices.map((choice) => (
              <option key={choice.id} value={choice.id}>
                {choice.label}
              </option>
            ))}
          </select>
        </div>
      )}

      <UrlMarkerForm url={url} setUrl={setUrl} />
    </>
  );
};
export default RessourceMarkerForm;
